import { Link } from 'react-router-dom'
import '../styles/not-found.css'

export function NotFound() {
  return (
    <main className="not-found-container">
      <h1 className="not-found-code">404</h1>
      <p className="not-found-message">Page not found.</p>
      <Link to="/" className="not-found-link">
        ← Back to home
      </Link>
    </main>
  )
}
